import React, { ReactElement } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';
import { Layout } from 'antd';
import Header from '@common/components/Header';
import Sider from '@common/components/Sider';
import * as Styled from './HeaderNavLayout.styled';

interface HeaderNavLayoutProps {
  headerActions?: ReactElement;
}

const HeaderNavLayout: React.FC<HeaderNavLayoutProps> = ({ headerActions }: HeaderNavLayoutProps): ReactElement => {
  const [searchParams] = useSearchParams();
  const hideNavBar = searchParams.get('hideNavBar') === 'true';

  const mainLayout = (
    <>
      <Header>{headerActions}</Header>
      <Layout>
        <Sider />
        <Layout>
          <Outlet />
        </Layout>
      </Layout>
    </>
  );

  return (
    <Styled.LayoutContainer isDisplayedInIframe={hideNavBar}>
      {/* hide header and sider when hideNavBar is true */}
      {!hideNavBar ? mainLayout : <Outlet />}
    </Styled.LayoutContainer>
  );
};

export default HeaderNavLayout;
